<template>
  <v-container fluid>
    <v-card outlined max-width="800">
      <div class="mx-6 mt-4">
        <span class="title mb-10"> Create Domains </span>
          <!-- background-color="rgba(48, 127, 255, 0.1)" -->
        <v-combobox
          v-model="selected_domains"
          :items="domains_list"
          label="Domains"
          domains
          clearable
          solo
          multiple
          id="domains"
          item-text="domain"
          item-value="id"
          outlined
          class="mt-4"
        >
          <!-- @change="$emit('selectedDomains', $event)" -->
          <template v-slot:selection="data">
            <v-chip
              :input-value="data.selected"
              close
              clearable
              @click:close="remove_domain(data.item.id)"
            >
              <strong>{{ data.item.domain }}</strong>
            </v-chip>
          </template>
        </v-combobox>
      </div>
      <v-row class="mx-4">
        <v-col md="6">
          <v-text-field v-model="new_domain" label="New Domain" />
        </v-col>
        <v-col sm="5" offset-sm="1">
          <v-checkbox
            label="Importance"
            v-model="importance"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row class="mx-4">
        <v-col md="2">
          <v-text-field
            v-model="domain.scheme"
            :loading="text_loader"
            label="Scheme"
            disabled
          />
        </v-col>
        <v-col md="4">
          <v-text-field
            v-model="domain.domain"
            :loading="text_loader"
            label="Domain"
            disabled
          />
        </v-col>
        <v-col md="6">
          <span v-if="domain.exists === false" class="error--text"
            >This domain does not exists</span
          >
          <span v-else-if="domain.exists === true" class="success--text"
            >This domain exists</span
          >
          <span v-else-if="domain.exists === null" class="secondary--text"
            >Empty Domain. Enter a Url for check</span
          >
        </v-col>
      </v-row>
      <v-row class="mx-4">
        <v-col md="6">
          <v-select
            v-model="selected_client"
            :items="clients"
            outlined
            label="Link a client"
          ></v-select>
        </v-col>
        <v-col>
          <v-btn
            large
            class="my-auto"
            color="purple"
            :disabled="domain.exists || text_loader || create_loader"
            @click="save_domain"
            :loading="create_loader"
            >Save Domain</v-btn
          >
            <!-- :disabled="!(domain.exists && !text_loader)" -->
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */

export default {
  name: "create-domain",
  data() {
    return {
      new_domain: "",
      domain: {},
      domain_init: {
        exists: null,
        scheme: "",
        domain: "",
        domain_id: null,
      },
      text_loader: false,
      create_loader: false,
      selected_client: 0,
      importance: true,
    };
  },
  computed: {
    domains_list() {
      const domains = this.$store.state.productionModule.domains;
      return domains.length > 2 ? domains : [];
    },
    selected_domains: {
      get() {
        return this.$store.state.productionModule.product_filter
          .selected_domains;
      },
      set(value) {
        this.$store.commit("productionModule/SET_SELECTED_DOMAINS", value);
      },
    },
    clients_list() {
      return this.$store.state.productionModule.clients_list;
    },
    clients() {
      return this.clients_list
        ? this.clients_list.map(
            (c) =>
              c.active && {
                text: c.text,
                value: c.value,
              }
          )
        : [];
    },
    domain_exists() {
      return !this.domain.exists;
    },
    selected_client_flag() {
      return !!this.selected_client;
    },
  },
  methods: {
    remove_domain(domain_id) {
      this.selected_domains = this.selected_domains.filter(
        (x) => x.id !== domain_id
      );
    },
    loadDomains() {
      if (this.domains_list.length == 0) {
        const payload = { task: "loadDomains" };
        this.$store
          .dispatch("productionModule/general_api", payload)
          .then((res) => {
            console.log("domains", res.data);
            this.$store.commit(
              "productionModule/SET_DOMAINS",
              res.data.domains
            );
          });
      }
    },
    check_domain() {
      this.text_loader = true;
      const params = {
        task: "check_domain",
        payload: {
          domain: this.new_domain,
        },
      };
      this.$store
        .dispatch("productionModule/general_api", params)
        .then((res) => {
          console.log("success", res.data);
          const payload = res.data.payload;
          this.domain.exists = payload.exists;
          this.domain.scheme = payload.scheme;
          this.domain.domain = payload.domain;
          this.domain.domain_id = payload.domain_id;
          this.$emit('snackbar_show',{text: res.data.message});
        })
        .catch((err) => console.log("error", err))
        .finally(() => {
          this.text_loader = false;
        });
    },
    save_domain() {
      console.log("save_domain");
      this.create_loader = true;
      const params = {
        task: "create_domain",
        payload: {
          domain: this.new_domain,
          client_id: this.client_id,
          importance: this.importance,
        },
      };
      this.$store
        .dispatch("productionModule/general_api", params)
        .then((res) => {
          const payload = res.data.payload;
          console.log("create_domain", payload);
          const message = res.data.message;
          this.$emit('snackbar_show',{text: message});
        })
        .catch((err) => console.log("error", err))
        .finally(() => {
          this.create_loader = false;
        });
    },
  },
  watch: {
    new_domain(newValue, oldValue) {
      if (!!newValue && newValue.length > 2 && newValue !== oldValue) {
        this.check_domain();
      }
    },
  },
  mounted() {
    this.loadDomains();
    this.domain = Object.assign({}, this.domain_init);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/Domains.vue